import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WasteEnergyTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";

const WasteEnergyContent = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_ENERGY")}
        subDescription={t("SURPLUS_ENERGY_INFO")}
        isNormal={true}
        number={"8.1.4"}
      />
      {showTable && <WasteEnergyTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WasteEnergyContent;
